<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    title="提现记录"
    :width="1150"
    :open="true"
    :confirmLoading="state.loading"
    :maskClosable="false"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    ><a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="代理商">
                <a-input v-model:value="queryParam.nickname" placeholder="代理商姓名或手机号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" name="status">
                <a-select mode="multiple" v-model:value="queryParam.status" placeholder="请选择">
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">审核通过</a-select-option>
                  <a-select-option :value="3">失败退款</a-select-option>
                  <a-select-option :value="4">已打款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="类型" name="type">
                <a-select mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                  <a-select-option :value="1">转让余额</a-select-option>
                  <a-select-option :value="2">直接提现</a-select-option>
                  <a-select-option :value="3">微信红包</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination" @change="onChange" rowKey="id">
        <template #bodyCell="{ column, record, index, text }">
          <template v-if="column.dataIndex === 'nickname'">
            <a>{{ record.nickname }}</a>
            <a-tag v-if="record.type == 1" color="green">转入余额</a-tag>
            <a-tag v-if="record.type == 2" color="green">直接提现</a-tag>
            <a-tag v-if="record.type == 3" color="green">微信红包</a-tag>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <a v-if="record.status == 1">申请中</a>
            <a v-if="record.status == 2">审核通过</a>
            <p v-if="record.status == 3">失败退款</p>
            <p v-if="record.status == 4">已打款</p>
          </template>
          <template v-if="column.dataIndex === 'tixian_invoice'">
            <template v-for="(item, index) in record.tixian_invoice">
              <a-image
                v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                :width="60"
                :height="60"
                :key="index"
                :src="$store.state.user.image_domain + item.url"
              ></a-image>
              <a :href="$store.state.user.image_domain + item.url" target="_blank" v-else>{{ item.name }}</a>
            </template>
          </template>
          <template v-if="column.dataIndex === 'tixian_remark'">
            <p>{{ record.tixian_remark }}</p>
            <a v-if="record.check_remark">{{ record.check_remark }}</a>
          </template>
          <template v-if="column.dataIndex === 'operate'">
            <a-popconfirm
              title="确定审核?"
              v-if="record.status == 1 && state.user_permission == 'admin'"
              placement="left"
              @openChange="
                (e) => {
                  openCheckChange(e, record)
                }
              "
              @confirm="sendCheck(record)"
            >
              <template #description>
                <a-form style="width: 500px; margin-top: 30px" v-bind="formLayout">
                  <a-form-item label="状态" required>
                    <a-radio-group v-model:value="record.audit_status">
                      <a-radio :value="1">审核通过</a-radio>
                      <a-radio :value="2">不通过、退回金额</a-radio>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item label="备注">
                    <a-input v-model:value="record.audit_remark" placeholder="请输入备注" style="width: 320px"> </a-input>
                  </a-form-item>
                </a-form>
              </template>
              <a>审核</a>
            </a-popconfirm>
            <a-popconfirm v-if="record.status == 2 && state.user_permission == 'admin'" title="确定已转款?" placement="left" @openChange="(e) => {}" @confirm="sendAudit(record)">
              <a>确认转款</a>
            </a-popconfirm>
          </template>
        </template>
      </a-table>
    </a-card>
  </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import Upload from '@/components/base/Upload.vue'
import { useStore } from 'vuex'
const $store = useStore()
const props = defineProps({})
const emit = defineEmits(['cancel'])
const columns = [
  {
    title: '代理商',
    dataIndex: 'nickname',
    width: 150
  },
  {
    title: '提现金额',
    dataIndex: 'tixian_amount',
    width: 150
  },
  {
    title: '发票',
    dataIndex: 'tixian_invoice',
    width: 300
  },
  {
    title: '提现备注',
    dataIndex: 'tixian_remark',
    width: 300
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100
  },
  {
    title: '时间',
    dataIndex: 'created_at',
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 200
  }
]
const formLayout = {
  labelCol: {
    xs: { span: 4 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 16 },
    sm: { span: 16 }
  }
}
interface state {
  loading: boolean
  detailData: object
  tixianVisible: boolean
  user_permission: string
}
const state = reactive<state>({
  loading: false,
  detailData: {},
  tixianVisible: false,
  user_permission: 'seller'
})
let queryParam = reactive<any>({
  full_name: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
  current: 1,
  total: undefined,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total) => `总数：${total}`
})
onMounted(() => {
  loadData()
})
const loadData = () => {
  state.loading = true
  // 获取到列表数据
  let requestParam = {
    url: '/admin/v1/freemoney/tixianList',
    method: 'post',
    data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
  }
  baseService(requestParam).then((res) => {
    state.loading = false
    pagination.total = res.data.total_records
    dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    state.user_permission = res.data.user_permission
  })
}
const onChange = (val) => {
  pagination.pageSize = val.pageSize
  pagination.current = val.current
  loadData()
}
const onFormSubmit = () => {
  emit('cancel')
}
// 审核
const openCheckChange = (e, record) => {
  record.audit_status = 1
  record.audit_remark = ''
  if (!e) {
    record.audit_status = null
    record.audit_remark = null
  }
}
const sendCheck = (record) => {
  if (record.audit_status == 2 && !record.audit_remark) {
    message.warn('不通过时，请填写备注')
    return new Promise((resolve, reject) => {
      reject()
    })
  }
  let requestParam = {
    url: '/admin/v1/freemoney/tixianCheck',
    method: 'post',
    data: {
      id: record.id,
      audit_status: record.audit_status,
      audit_remark: record.audit_remark
    }
  }
  baseService(requestParam)
    .then((res: any) => {
      message.success(res.msg)
      loadData()
    })
    .catch((res) => {
      if (res.msg) {
        message.error(res.msg)
      } else {
        message.error('操作失败,请联系管理员')
      }
    })
  return null
}
const sendAudit = (record) => {
  let requestParam = {
    url: '/admin/v1/freemoney/tixianAudit',
    method: 'post',
    data: {
      id: record.id
    }
  }
  baseService(requestParam).then((res: any) => {
    message.success(res.msg)
    loadData()
  })
}
</script>
<style lang="less" scoped>
.customer-options-popover {
  p {
    padding: 0 16px;
    margin: 0;
    height: 35px;
    line-height: 35px;
    cursor: pointer;
    text-align: center;
    color: #000;
  }

  p:hover {
    color: var(--ant-primary-color);
    background: var(--ant-primary-color-deprecated-bg);
  }
}
</style>
